<div class="flex-row">
    <div class="flex-grid-3">
        <div
                (click)="openUserProfile(user.id)"
                class="
        tiny-card
        user
        center-content
        glass-blurred-background
        drop-shadow
        text-center
      "
                *ngFor="let user of filteredUserList; let i = index"
        >
            <img *ngIf="user.profileImg"
                 class="space-below  list-avatar"
                 [src]="user.profileImg |s3Link"
            />

            <img *ngIf="!user.profileImg"
                 class="space-below svg-white list-avatar"
                 src="./assets/imgs/avatar.svg"
            />
            <div class="user-name">{{ user.lastname | titlecase }} {{ user.name |titlecase }} </div>
            <div class="user-role">{{ user.permessions }}</div>
        </div>
    </div>
</div>

<div class="floating-btn drop-shadow" (click)="addUser()">+</div>
